import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/resources/page.tsx");
